import styled, { css } from "styled-components"
import { AnimationDismissType, FADE_OUT_DURATION_IN_SECONDS, FLOATING_BUTTON_DURATION_IN_SECONDS } from "../burnout-animation-constants";

interface IBurnoutAnimationContainerProps {
    animationEnded: boolean;
    dismissType: AnimationDismissType;
    viewportHeight: number;
    zIndex: number;
}

export const BurnoutAnimationContainer = styled.div<IBurnoutAnimationContainerProps>`
    /* Position the container in the viewport, covering all visible area from top to bottom */
    position: fixed;
    top: 0;
    height: ${({viewportHeight}) => viewportHeight}px;
    /* it should be as wide as it can but no wider than 800px or the height of the viewport whichever is smaller
    Why no wider than 100vh? Because on very wide landscape screens (landscape mobile phones for example)
    we want to contain the animation in a square of the size equal to the height of the screen, any bigger, it will cut top and bottom part */
    width: 100%;
    max-width: min(${({viewportHeight}) => viewportHeight}px, 100vh, 800px);
    /* Horizontal alignment in viewport with right and transform */
    right: 50%;
    transform: translateX(50%);
    /* A big z-index, to make sure it's above everything */
    z-index: ${({zIndex}) => zIndex};
    /* Allow clicks to go through the animation elements so that the user can control the gameplay for example */
    pointer-events: none;
    /* overflow: hidden; */
    opacity: 1;
    ${({animationEnded, dismissType}) => animationEnded ? (
        dismissType === AnimationDismissType.FadeOut ? css`
            transition: opacity ${FADE_OUT_DURATION_IN_SECONDS}s;
            opacity: 0;
        ` : css`
            transition: height ${FLOATING_BUTTON_DURATION_IN_SECONDS}s, width ${FLOATING_BUTTON_DURATION_IN_SECONDS}s, max-width ${FLOATING_BUTTON_DURATION_IN_SECONDS}s, top ${FLOATING_BUTTON_DURATION_IN_SECONDS}s, right ${FLOATING_BUTTON_DURATION_IN_SECONDS}s, border-radius ${FLOATING_BUTTON_DURATION_IN_SECONDS}s, opacity ${FLOATING_BUTTON_DURATION_IN_SECONDS}s;
            height: 60px;
            width: 60px;
            max-width: 60px;
            overflow: hidden;
            top: 75px;
            right: 60px;
            @media ${({theme}) => theme.mediaQuery.sAndBelow } {
                right: 40px;
            }
            border-radius: 50%;
            pointer-events: auto;
            opacity: 0.91;
        `
    ) : ''};

`;
